import { render, staticRenderFns } from "./StaticResource.vue?vue&type=template&id=cb7fa85e&scoped=true&"
import script from "./StaticResource.vue?vue&type=script&lang=js&"
export * from "./StaticResource.vue?vue&type=script&lang=js&"
import style0 from "./StaticResource.vue?vue&type=style&index=0&id=cb7fa85e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7fa85e",
  null
  
)

component.options.__file = "StaticResource.vue"
export default component.exports